/*
 * @Author: 吴文洁
 * @Date: 2019-08-30 10:04:15
 * @LastEditors: 吴文洁
 * @LastEditTime: 2019-09-02 10:11:46
 * @Description: 格式化时间过滤器
 */
export default function formatDate(timestamp: number, format: string, ): string {
  if (!timestamp) return '';

  const date: Date = new Date(Number(timestamp));
  let y: number | string = date.getFullYear(),
    m: number | string = date.getMonth() + 1,
    d: number | string = date.getDate(),
    h: number | string = date.getHours(),
    i: number | string = date.getMinutes(),
    s: number | string = date.getSeconds(),
    w: number | string = date.getDay(),
    week: ReadonlyArray<string> = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  h = h < 10 ? '0' + h : h;
  i = i < 10 ? '0' + i : i;
  s = s < 10 ? '0' + s : s;

  return format.replace('YYYY', y.toString())
    .replace('MM', m.toString())
    .replace('DD', d.toString())
    .replace('H', h.toString())
    .replace('i', i.toString())
    .replace('s', s.toString())
    .replace('WW', week[w]);
}